import React from "react";
import { useOrgs } from "lib/reauth/ReauthModule";
import PropTypes from "prop-types";

function OrgSelect({
                       value,
                       excludes = [],
                       onChange,
                       allowBlank = false,
                       title,
                   }) {
    const allOrgs = useOrgs();
    const orgs = React.useMemo(
        () => {
            const s = new Set(excludes);
            return allOrgs.filter(o => !s.has(o));
        },
        [allOrgs, excludes],
    );
    return <select
        value={value}
        onChange={onChange}
        title={title}
        disabled={orgs.length === 0}
    >
        {allowBlank && <option />}
        {orgs.map(o =>
            <option key={o}>{o}</option>)}
    </select>;
}

OrgSelect.propTypes = {
    value: PropTypes.string.isRequired,
    excludes: PropTypes.arrayOf(PropTypes.string),
    onChange: PropTypes.func.isRequired,
    allowBlank: PropTypes.bool,
    title: PropTypes.string,
};

export default OrgSelect;



// WEBPACK FOOTER //
// ./app/lib/reauth/OrgSelect.js